import { Search, Wind, Repeat, FlaskConical, Bug, Zap, Truck } from "lucide-react";
import { Reveal } from "./Motion";

const ITEMS = [
  { icon: Search, title: "Recherche & élimination des sources de larves", text: "Nous traquons chaque gîte larvaire : soucoupes, gouttières, regards, bâches, récupérateurs d'eau. Sans larves, pas de nouvelle génération.", span: "lg:col-span-2 lg:row-span-2", tone: "dark", big: true },
  { icon: Wind, title: "Nébulisation & atomiseur", text: "Tout l'extérieur est traité : bois, végétaux, haies, mobilier, bâti, zones d'ombre.", span: "lg:col-span-2", tone: "lime" },
  { icon: Zap, title: "99 % d'efficacité", text: "Action rapide, effet choc dès le passage.", span: "", tone: "light", stat: "99%" },
  { icon: Truck, title: "Déplacement inclus", text: "Partout à Bordeaux et en Gironde.", span: "", tone: "sand" },
  { icon: FlaskConical, title: "Biocides professionnels", text: "Produits réservés aux professionnels pour un traitement choc anti-moustiques.", span: "lg:col-span-2", tone: "sand" },
  { icon: Bug, title: "Tous types de moustiques", text: "Moustique tigre, moustique commun, moustiques des marais…", span: "", tone: "light" },
  { icon: Repeat, title: "Plusieurs passages possibles", text: "Un suivi adapté à la saison et à la pression de votre secteur.", span: "", tone: "dark" },
];

const tones = {
  dark: "bg-forest text-cream border-forest",
  lime: "bg-lime text-forest border-lime",
  light: "bg-white text-forest border-moss/15",
  sand: "bg-sand text-forest border-sand",
};

export const Bento = () => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:auto-rows-[minmax(210px,auto)]" data-testid="treatment-bento">
    {ITEMS.map((it, i) => (
      <Reveal key={it.title} delay={0.05 * i} className={`${it.span} h-full`}>
        <article className={`group relative h-full overflow-hidden rounded-3xl border p-7 md:p-8 flex flex-col justify-between transition-transform duration-500 hover:-translate-y-1 ${tones[it.tone]}`} data-testid={`bento-card-${i}`}>
          {it.big && <img src="/images/eau-stagnante.webp" alt="Eau stagnante dans un jardin, gîte larvaire de moustiques" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-35 transition-transform duration-[1.4s] group-hover:scale-105" />}
          <div className="relative flex items-start justify-between gap-4">
            <span className={`w-12 h-12 rounded-2xl grid place-items-center ${it.tone === "dark" ? "bg-lime text-forest" : "bg-moss text-cream"}`}><it.icon className="w-5 h-5" /></span>
            {it.stat && <span className="font-display text-6xl font-extrabold tracking-tighter text-moss">{it.stat}</span>}
          </div>
          <div className={`relative ${it.big ? "mt-40" : "mt-10"}`}>
            <h3 className={`font-display font-extrabold leading-tight ${it.big ? "text-3xl md:text-4xl" : "text-xl"}`}>{it.title}</h3>
            <p className={`mt-3 text-[15px] leading-relaxed ${it.tone === "dark" ? "text-cream/80" : "text-forest/75"}`}>{it.text}</p>
          </div>
        </article>
      </Reveal>
    ))}
  </div>
);
